
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quiz/[quizSlug]/[quizUID]",
      function () {
        return require("private-next-pages/quiz/[quizSlug]/[quizUID].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quiz/[quizSlug]/[quizUID]"])
      });
    }
  